import { Component, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CustomNodeComponent } from 'ngx-vflow';
import { VflowModule } from 'ngx-vflow';
import { NetworkAssetTypes } from 'src/app/enums/network-asset-types.enum';
import { CommonModule } from '@angular/common';
import { KeyValueItem, KeyValuePair } from 'src/app/models/keyValueItem.model';
import { MoreOptionsService } from 'src/app/services/moreOptions.service';
import { NavigationExtras, Router } from '@angular/router';
import { SubstationService } from 'src/app/services/substation.service';
import { SubstationCrud } from 'src/app/models/substation.model';
import { ToastrService } from 'ngx-toastr';
import { DtService } from 'src/app/services/dt.service';
import { TranslateModule } from '@ngx-translate/core';

export interface NodeInfo {
  id: number;
  label: string;
  name: string;
  type: NetworkAssetTypes;
  borderColor: string;
  isStats: boolean;
  statistics: KeyValuePair[];
  excludeIds: number[];
  parentId?: number;
  parentType?: NetworkAssetTypes;
  isShowMore: boolean;
}

@Component({
  selector: 'app-network-asset-node',
  templateUrl: './network-asset-node.component.html',
  styleUrls: ['./network-asset-node.component.scss'],
  standalone: true,
  imports: [CommonModule, VflowModule, TranslateModule]
})
export class NetworkAssetNodeComponent extends CustomNodeComponent<NodeInfo> {
  substations: SubstationCrud[] = [];

  parentName?: string;
  
  constructor(private moreOptionsService : MoreOptionsService,
              private dtService: DtService
  ){
    super();
  }
  showMore(obj:any) {
    this.moreOptionsService.setNode(obj);
  }

  openListPage(asset: string, parentId?: number, parentType?: NetworkAssetTypes) {
    const parentTypeInt = parseInt(NetworkAssetTypes[parentType as NetworkAssetTypes]); 
    if (parentId !== undefined) {
      this.dtService.getDtIdsForNetworkAssets(parentId!, parentType!).subscribe(
        data => {
          localStorage.setItem('dtIds', JSON.stringify(data.data.dtIds));
          localStorage.setItem('assetName', data.data.assetName);

          switch(asset) {
            case 'Distribution Substation':
              var url = `/transformers`;
              window.open(url, '_blank');
              break;
            case 'Poles':
              var url = `/poles`;
              window.open(url, '_blank');
              break;
            case 'Buildings':
              var url = `/buildings`;
              window.open(url, '_blank');
              break;
            case 'Customers':
              var url = `/customers`;
              window.open(url, '_blank'); 
              break;  
            default:
              break;
          }
        },
        error => {
          console.log(error);
        }
      );  
    }
  }
} 
